import React from "react";

import { useFormikContext } from "formik";

import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const ConfirmMintModal = (props) => {
    const { open, handleClose } = props;
    const { submitForm } = useFormikContext();
    const actiopProps = {
        header: "Mint token",
        text: "You are going to mint your token(s) in blockchain. Please confirm this action.",
    };

    const close = () => {
        handleClose();
    };

    const confirm = () => {
        submitForm();
        handleClose();
    };
    return (
        <div>
            <Dialog open={open} onClose={close} disableEscapeKeyDown fullWidth>
                <DialogTitle>{actiopProps.header}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{actiopProps.text}</DialogContentText>
                </DialogContent>
                <Box sx={{ p: "0 2rem 2rem 2rem" }}>
                    <DialogActions>
                        <Button onClick={confirm}>Confirm</Button>
                        <Button onClick={close}>Cancel</Button>
                    </DialogActions>
                </Box>
            </Dialog>
        </div>
    );
};

export default ConfirmMintModal;
